import React, { Suspense, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import BranchPage from './pages/BranchPage';
import BookingPage from './pages/BookingPage';
import TermsPage from './pages/TermsPage';
import useReveal from './hooks/useReveal';
import { scrollToId } from './services/booking';
import './styles/App.css';

// The resource curriculum carries a lot of text, so it loads as its own
// chunk instead of weighing down the storefront bundle.
const ResourcesPage = React.lazy(() => import('./pages/ResourcesPage'));
const ResourceArticlePage = React.lazy(() => import('./pages/ResourceArticlePage'));

/** Scroll to top on route change; honour #hash targets after paint. */
const ScrollManager: React.FC = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      window.requestAnimationFrame(() => scrollToId(id));
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

const App: React.FC = () => {
  const { pathname } = useLocation();
  useReveal(pathname);

  return (
    <div className="app">
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <ScrollManager />
      <Header />
      <main id="main">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/resources"
            element={
              <Suspense fallback={null}>
                <ResourcesPage />
              </Suspense>
            }
          />
          <Route
            path="/resources/:slug"
            element={
              <Suspense fallback={null}>
                <ResourceArticlePage />
              </Suspense>
            }
          />
          <Route path="/:branchId" element={<BranchPage />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default App;
